import { render } from "./InputSwitch.vue?vue&type=template&id=535a8438&scoped=true"
import script from "./InputSwitch.vue?vue&type=script&lang=js"
export * from "./InputSwitch.vue?vue&type=script&lang=js"

import "./InputSwitch.vue?vue&type=style&index=0&id=535a8438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a8438"]])

export default __exports__